import styled from 'styled-components';
import { mixins } from '@sy/component-library';

const { media } = mixins;

export const Post = styled.a`
	border-radius: 12px;
	display: flex;
	flex-direction: column;
	box-shadow: ${({ theme }) => theme.shadows.subtle};
	overflow: hidden;
	cursor: pointer;
	text-decoration: none;

	&:focus {
		box-shadow: ${({ theme }) => theme.shadows.medium};
	}
`;

export const PostThumbnail = styled.div`
	height: 216px;
	width: 100%;
	position: relative;
	${media.belowMedium`
		width: 100%;
	`}
`;

export const PostData = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 16px;
`;

export const PostTitle = styled.div`
	font-weight: 700;
	font-size: 1.8rem;
	line-height: 130%;
	display: flex;
	flex-direction: row;
	justify-content: center;
	color: ${({ theme }) => theme.colors.black};
	margin-bottom: 10px;
`;

export const PostReadMoreWrapper = styled.div`
	display: flex;
	flex: 1;
	align-items: flex-end;
`;

export const PostReadMore = styled.span`
	font-weight: 400;
	font-size: 1.4rem;
	line-height: 150%;
	text-decoration: none;
	color: ${({ theme }) => theme.colors.blue.main};
	margin-top: 6px;
`;

export const PostSummary = styled.span`
	color: ${({ theme }) => theme.colors.grey[800]};
	font-weight: 400;
	font-size: 1.4rem;
	line-height: 150%;
	margin-bottom: 10px;
`;
